import { render, staticRenderFns } from "./privacy_agreement.vue?vue&type=template&id=0617be62&scoped=true"
import script from "./privacy_agreement.vue?vue&type=script&lang=js"
export * from "./privacy_agreement.vue?vue&type=script&lang=js"
import style0 from "./privacy_agreement.vue?vue&type=style&index=0&id=0617be62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0617be62",
  null
  
)

export default component.exports